import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button,
  Card,
  Checkbox,
  Dropdown,
  Form,
  Icon,
  Input,
  InputNumber,
  Pagination,
  Popover,
  Menu,
  Modal,
  Radio,
  Select,
  Table,
  Tabs,
} from 'antd';
import { Link } from 'react-router-dom';

export function translateThemeConsts(propValue, props) {
  let translated = propValue;
  Object.keys(props.theme.dimensions).forEach((key) => {
    const regex = new RegExp(`\\b${key}\\b`, 'g');
    translated = translated.replace(regex, props.theme.dimensions[key]);
  });
  Object.keys(props.theme.colors).forEach((key) => {
    const regex = new RegExp(`\\b${key}\\b`, 'g');
    translated = translated.replace(regex, props.theme.colors[key]);
  });
  return translated;
}

function styledComponent(componentOrTagName) {
  const component = styled(componentOrTagName)`
    // Layout props
    ${props => (props.width ? `width: ${translateThemeConsts(props.width, props)}` : '')};
    ${props => (props.height ? `height: ${translateThemeConsts(props.height, props)}` : '')};
    ${props => (props.margin ? `margin: ${props.margin}` : '')};
    ${props => (props.padding ? `padding: ${props.padding}` : '')};
    ${props => (props.minWidth ? `min-width: ${translateThemeConsts(props.minWidth, props)}` : '')};
    ${props => (props.minHeight ? `min-height: ${translateThemeConsts(props.minHeight, props)}` : '')};
    ${props => (props.maxWidth ? `max-width: ${translateThemeConsts(props.maxWidth, props)}` : '')};
    ${props => (props.maxHeight ? `max-height: ${translateThemeConsts(props.maxHeight, props)}` : '')};
    ${props => (props.position ? `position: ${props.position}` : '')};
    ${props => (props.top ? `top: ${props.top}` : '')};
    ${props => (props.right ? `right: ${props.right}` : '')};
    ${props => (props.bottom ? `bottom: ${props.bottom}` : '')};
    ${props => (props.left ? `left: ${props.left}` : '')};

    ${props => (props.justifyContent ? `justify-content: ${props.justifyContent}` : '')};
    ${props => (props.alignItems ? `align-items: ${props.alignItems}` : '')};
    ${props => (props.alignContent ? `align-content: ${props.alignContent}` : '')};
    ${props => (props.flexWrap ? `flex-wrap: ${props.flexWrap}` : '')};
    ${props => (props.flexGrow ? `flex-grow: ${props.flexGrow}` : '')};
    ${props => (props.flexShrink ? `flex-shrink: ${props.flexShrink}` : '')};
    ${props => (props.flexBasis ? `flex-basis: ${props.flexBasis}` : '')};
    ${props => (props.alignSelf ? `align-self: ${props.alignSelf}` : '')};

    ${props => (props.background ? `background: ${translateThemeConsts(props.background, props)}` : '')};
    ${props => (props.backgroundColor ? `background-color: ${translateThemeConsts(props.backgroundColor, props)}` : '')};
    ${props => (props.backgroundSize ? `background-size: ${translateThemeConsts(props.backgroundSize, props)}` : '')};
    ${props => (props.border ? `border: ${translateThemeConsts(props.border, props)}` : '')};
    ${props => (props.borderTop ? `border-top: ${translateThemeConsts(props.borderTop, props)}` : '')};
    ${props => (props.borderRight ? `border-right: ${translateThemeConsts(props.borderRight, props)}` : '')};
    ${props => (props.borderBottom ? `border-bottom: ${translateThemeConsts(props.borderBottom, props)}` : '')};
    ${props => (props.borderLeft ? `border-left: ${translateThemeConsts(props.borderLeft, props)}` : '')};
    ${props => (props.borderRadius ? `border-radius: ${props.borderRadius}` : '')};
    ${props => (props.borderTopLeftRadius ? `border-top-left-radius: ${translateThemeConsts(props.borderTopLeftRadius, props)}` : '')};
    ${props => (props.borderTopRightRadius ? `border-top-right-radius: ${translateThemeConsts(props.borderTopRightRadius, props)}` : '')};
    ${props => (props.borderBottomLeftRadius ? `border-bottom-left-radius: ${translateThemeConsts(props.borderBottomLeftRadius, props)}` : '')};
    ${props => (props.borderBottomRightRadius ? `border-bottom-right-radius: ${translateThemeConsts(props.borderBottomRightRadius, props)}` : '')};
    ${props => (props.boxShadow ? `box-shadow: ${props.boxShadow}` : '')};
    ${props => (props.cursor ? `cursor: ${props.cursor}` : '')};
    ${props => (props.opacity ? `opacity: ${props.opacity}` : '')};
    ${props => (props.display ? `display: ${props.display}` : '')};
    ${props => (props.float ? `float: ${props.float}` : '')};
    ${props => (props.transform ? `transform: ${props.transform}` : '')};
    ${props => (props.transition ? `transition: ${props.transition}` : '')};
    ${props => (props.overflow ? `overflow: ${props.overflow}` : '')};
    ${props => (props.zIndex ? `z-index: ${props.zIndex}` : '')};

    // Font props
    ${props => (props.textAlign ? `text-align: ${props.textAlign}` : '')};
    ${props => (props.color ? `color: ${translateThemeConsts(props.color, props)}` : '')};
    ${props => (props.font ? `font: ${props.font}` : '')};
    ${props => (props.fontSize ? `font-size: ${props.fontSize}` : '')};
    ${props => (props.fontStyle ? `font-style: ${props.fontStyle}` : '')};
    ${props => (props.fontWeight ? `font-weight: ${props.fontWeight}` : '')};
    ${props => (props.lineHeight ? `line-height: ${props.lineHeight}` : '')};
    ${props => (props.letterSpacing ? `letter-spacing: ${props.letterSpacing}` : '')};
    ${props => (props.whiteSpace ? `white-space: ${props.whiteSpace}` : '')};
    ${props => (props.uppercase ? 'text-transform: uppercase;' : '')};
    ${props => (props.ellipsis ? 'overflow: hidden; white-space:nowrap; text-overflow:ellipsis;' : '')};

    // Other props specialized for different elements.
    ${props => (props.listStyle ? `list-style: ${props.listStyle}` : '')};
    ${props => (props.objectFit ? `object-fit: ${props.objectFit}` : '')};

    // Some commonly used styles for hover state.
    &&:hover {
      // Layout props
      ${props => (props.widthHover ? `width: ${translateThemeConsts(props.widthHover, props)}` : '')};
      ${props => (props.backgroundHover ? `background: ${translateThemeConsts(props.backgroundHover, props)}` : '')};
      ${props => (props.backgroundColorHover ? `background-color: ${translateThemeConsts(props.backgroundColorHover, props)}` : '')};
      ${props => (props.borderHover ? `border: ${translateThemeConsts(props.borderHover, props)}` : '')};
      ${props => (props.borderTopHover ? `border-top: ${translateThemeConsts(props.borderTopHover, props)}` : '')};
      ${props => (props.borderRightHover ? `border-right: ${translateThemeConsts(props.borderRightHover, props)}` : '')};
      ${props => (props.borderBottomHover ? `border-bottom: ${translateThemeConsts(props.borderBottomHover, props)}` : '')};
      ${props => (props.borderLeftHover ? `border-left: ${translateThemeConsts(props.borderLeftHover, props)}` : '')};
      ${props => (props.boxShadowHover ? `box-shadow: ${translateThemeConsts(props.boxShadowHover, props)}` : '')};
      ${props => (props.opacityHover ? `opacity: ${translateThemeConsts(props.opacityHover, props)}` : '')};
      ${props => (props.transformHover ? `transform: ${props.transformHover}` : '')};

      // Font props
      ${props => (props.colorHover ? `color: ${translateThemeConsts(props.colorHover, props)}` : '')};
    }
  `;

  // All components require width & height props.
  component.propTypes = {
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    ...component.propTypes,
  };

  // Component specific requirements.
  if (componentOrTagName === 'span') {
    component.propTypes = {
      color: PropTypes.string.isRequired,
      fontSize: PropTypes.string.isRequired,
      ...component.propTypes,
    };
  }

  return component;
}

export const FlexColContainer = styled(styledComponent('div'))`
  display: flex;
  flex-direction: column;
`;

export const FlexRowContainer = styled(styledComponent('div'))`
  display: flex;
  flex-direction: row;
`;

export default {
  // Basic html elements
  Div: styledComponent('div'), // In most cases, we should use FlexXXXContainer.
  Img: styledComponent('img'),
  Span: styledComponent('span'),
  I: styledComponent('i'),
  A: styledComponent('a'),
  Ul: styledComponent('ul'),
  Ol: styledComponent('ol'),
  Li: styledComponent('li'),
  H2: styledComponent('h2'),
  H3: styledComponent('h3'),
  H4: styledComponent('h4'),
  H5: styledComponent('h5'),
  // Don't add P here, always use Span.

  // Antd components
  AntdButton: styledComponent(Button),
  AntdCard: styledComponent(Card),
  AntdCheckbox: styledComponent(Checkbox),
  AntdDropdown: styledComponent(Dropdown),
  AntdForm: styledComponent(Form),
  AntdFormItem: styledComponent(Form.Item),
  AntdIcon: styledComponent(Icon),
  AntdInput: styledComponent(Input),
  AntdInputNumber: styledComponent(InputNumber),
  AntdInputSearch: styledComponent(Input.Search),
  AntdInputTextArea: styledComponent(Input.TextArea),
  AntdPagination: styledComponent(Pagination),
  AntdPopover: styledComponent(Popover),
  AntdMenu: styledComponent(Menu),
  AntdMenuItem: styledComponent(Menu.Item),
  AntdSubMenu: styledComponent(Menu.SubMenu),
  AntdModal: styledComponent(Modal),
  AntdRadio: styledComponent(Radio),
  AntdRadioGroup: styledComponent(Radio.Group),
  AntdRadioButton: styledComponent(Radio.Button),
  AntdSelect: styledComponent(Select),
  AntdTable: styledComponent(Table),
  AntdTabs: styledComponent(Tabs),
  AntdTabPane: styledComponent(Tabs.TabPane),

  // react-router components
  RouteLink: styledComponent(Link),
};
